import { render, staticRenderFns } from "./SithMesStoolTransferTicketGenerationRecordEdit.vue?vue&type=template&id=1933e46f&"
import script from "./SithMesStoolTransferTicketGenerationRecordEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolTransferTicketGenerationRecordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports